<!-- 保卫人员选择面板 -->
<template>
  <div
    class="dialog-app-panel group-transfer"
    :class="showPanel ? 'dialog-show' : ''"
  >
    <app-panel title="配置设备权限组" :isExpand="showPanel" @cancel="close">
      <div class="content">
        <div class="content-top">
          <div class="content-top-left">
            <div class="groupTitle">可选设备权限组</div>
            <div class="content-main">
              <el-input
                placeholder="请输入权限组名称"
                v-model="account"
                clearable
                style="margin: 10px; width: calc(100% - 20px)"
              >
              </el-input>
              <ul class="group-list">
                <el-scrollbar class="scroll-bar">
                  <el-tree
                    class="tree-list"
                    ref="tree"
                    node-key="code"
                    :data="treeData"
                    :props="props"
                    :renderContent="renderContent"
                    :filter-node-method="filterNode"
                    show-checkbox
                  >
                  </el-tree>
                </el-scrollbar>
              </ul>
            </div>
          </div>
          <div class="content-top-middle">
            <div style="text-align: center; margin-bottom: 30px">
              <img
                src="@src/common/assets/images/arrows_left.png"
                @click="transferPerson('right')"
                style="cursor: pointer"
                alt=""
              />
            </div>
            <div style="text-align: center">
              <img
                src="@src/common/assets/images/arrows_right.png"
                @click="transferPerson('left')"
                alt=""
                style="cursor: pointer"
              />
            </div>
          </div>
          <div class="content-top-right">
            <div class="groupTitle">已选设备权限组</div>
            <div class="content-main">
              <el-scrollbar class="scroll-bar">
                <ul class="person-list">
                  <li
                    v-for="(item, index) in selectedList"
                    :key="index"
                    class="person"
                  >
                    <el-checkbox v-model="item.checked"></el-checkbox>
                    <span class="checked-name" :title="item.name">{{
                      item.name
                    }}</span>
                  </li>
                </ul>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </app-panel>
  </div>
</template>

<script>
import { api } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  watch: {
    account(val) {
      this.$refs.tree.filter(val);
    },
  },
  components: {
    appPanel,
  },
  data() {
    return {
      showPanel: false,
      props: {
        label: "name",
        id: "code",
        isLeaf: "isLeaf",
      },
      treeData: [],
      selectedList: [],
      //判断是否已经开始懒加载
      isLoadNode: false,
      account: "",
      accountNumber: "",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    open(id) {
      this.accountNumber = id;
      this.showPanel = true;
      this.getRlatAccountGroup();
      this.getInList();
    },
    // 获取当前账户未绑定的设备权限组列表(可选)
    getRlatAccountGroup() {
      this.treeData = [];
      let params = {
        accountNumber: this.accountNumber,
      };
      this.$fetch(api.group.queryAccountNoAuthGroupList, params).then((res) => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            this.treeData = res.returnObj.map((item) => {
              return {
                code: item.authGroupCode,
                name: item.authGroupName,
                checked: false,
              };
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
        console.log(this.treeData, "this.treeData");
      });
    },
    // 获取当前账户已绑定的设备权限组
    getInList() {
      let params = {
        accountNumber: this.accountNumber,
      };
      this.$fetch(api.group.queryAccountAuthGroupList, params).then((res) => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            this.selectedList = res.returnObj.map((item) => {
              return {
                code: item.authGroupCode,
                name: item.authGroupName,
                checked: true,
              };
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
        console.log("this.selectedList", this.selectedList);
      });
    },
    // 自定义渲染节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>
      );
    },
    // 数组扁平化
    flattenArr(arr) {
      const self = this;
      return arr.reduce((flat, toFlatten) => {
        return flat.concat(
          Array.isArray(toFlatten) ? self.flattenArr(toFlatten) : toFlatten
        );
      }, []);
    },
    // 移动人员
    transferPerson(type) {
      if (type === "left") {
        console.log("--left---------");
        // 获取左边未选中的人员 (左侧列表勾选的)
        let selectedPerson = this.$refs.tree.getCheckedNodes();
        // console.log('选中的节点', selectedPerson, this.selectedList)
        if (selectedPerson.length) {
          this.selectedList = this.selectedList.concat(selectedPerson);
          let data = this.selectedList.map((item) => {
            return {
              code: item.code,
              name: item.name,
              checked: true,
            };
          });
          selectedPerson = selectedPerson.map((item) => {
            return {
              code: item.code,
              name: item.name,
              checked: true,
            };
          });
          // 人员根据账号去重
          this.selectedList = this.reduceArr(data, "code");
          // console.log(this.selectedList, '去重人员')

          // 当勾选中后改变左侧树checked的属性值
          this.treeData.forEach((item, index) => {
            selectedPerson.forEach((items) => {
              if (items.code === item.code) {
                item.checked = items.checked;
              }
            });
          });

          this.treeData = this.treeData.filter(
            (item) => item.checked === false
          );
        } else {
          selectedPerson = this.$refs.tree.getCheckedNodes(true);
        }
      } else if (type === "right") {
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(
            (item) => item.checked === true
          );
          this.selectedList = this.selectedList.filter(
            (item) => item.checked === false
          );
          this.treeData = this.treeData.concat(rightChoose);
          this.treeData = this.reduceArr(this.treeData, "code");
        } else {
          this.selectedList = [];
        }
        // console.log(this.treeData, '右 this.treeData已选人员')
      }
    },
    // 根据key对数组对象去重
    reduceArr(arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
        return cur;
      }, []);
      return newArr;
    },
    //点击确定按钮,对外暴露已选人员
    submit() {
      let chooseIds = [];
      if (this.selectedList.length) {
        this.selectedList
          .filter((item) => item.checked === true)
          .forEach((item) => {
            chooseIds.push(item.code);
          });
      }
      let params = {
        authGroupCodeList: chooseIds,
        accountNumber: this.accountNumber,
      };
      this.$fetch(api.group.updateAccountAuthGroup, params).then((res) => {
        if (res.success) {
          this.$message.success("配置设备权限组成功");
          this.close();
          this.$emit("refreshData");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    close() {
      this.showPanel = false;
      this.selectedList.length = 0;
      this.account = "";
    },
    // 懒加载节点
    loadNode(node, resolve) {
      if (node.data && node.data.code) {
        let accountGroupCode = node.data.code;
        // 获取当前账户组关联的人员
        this.$fetch(api.reserve.queryAccountGroup, { accountGroupCode }).then(
          (res) => {
            if (res.success) {
              if (res.returnObj && res.returnObj.length) {
                let childrenData = res.returnObj.map((item) => {
                  return {
                    code: item.authGroupCode,
                    name: `${item.authGroupName}(${item.authGroupCode})`,
                    isLeaf: true,
                  };
                });
                this.$set(node.data, "children", childrenData);
                resolve(childrenData);
                // this.childrenDataList = childrenData;
              } else {
                return resolve([]);
              }
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.group-transfer {
  height: 100%;
  width: 100%;
  .content {
    height: 100%;
    width: 100%;
    &-top {
      height: 100%;
      position: relative;
      display: flex;
      align-content: space-around;
      &-left,
      &-right {
        width: calc(100% / 2 - 30px);
        overflow: hidden;
        @include set_theme_color(background-color, page-default-bg);
        .group-list {
          height: calc(100% - 60px);
          .tree-list {
            // background: #0d121c !important;
            padding-bottom: 12px;
          }
          .el-tree-node__content {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #C0C4CC;
          }
        }
        .person-list {
          height: 100%;
          width: 100%;
          padding: 6px 16px 16px;

          .person {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #C0C4CC;
          }
          .checked-name {
            margin-left: 10px;
          }
        }
      }
      &-middle {
        width: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        .to-left {
          background: transparent;
          @include set_theme_color(color, active-border-color);
        }
        .to-right {
          background: transparent;
          @include set_theme_color(color, active-border-color);
        }
      }
    }
  }
  .scroll-bar {
    height: calc(100% - 0px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .groupTitle {
    height: 32px;
    // color: #fff;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    font-weight: normal;
  }
  .content-main {
    height: calc(100% - 30px);
    // background: #0d121c;
  }
}
</style>